/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import {Application} from "./application";

var $ = require('jquery');
require('./bootstrap');
require('./plugins/select2/js/select2.full.min');
require('./plugins/select2/js/i18n/cs');
require('./plugins/validator/validator.min');

const baseUrl = $('base').attr('href');
const urlRegexp = /^https?:\/\//gi;
$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
	},
	timeout: 5000,
	beforeSend: function(xhr, options) {
		if (!options.url.match(urlRegexp)) {
			options.url = baseUrl + '/' + options.url;
		}
	}
});

require('./common');
require('./helpers');

require('./androidAppInterface');
window.$androidAppInterface = new AndroidAppInterface();

require('./addressAutocomplete');

window.$application = new Application();

let $body = $('body');
let isWrongDoing = false;
switch ($body.attr('id')) {
	case 'dashboard':
		require('./plugins/morrisjs/morris.min');
		require('./dashboard');
		window.$dashboard = new Dashboard();
		break;
	
	case 'settings':
		require('./settings');
		window.$settings = new Settings();
		break;
		
	case 'demand':
		require('./demand');
		window.$demand = new Demand();
		break;
		
	case 'wrongDoings':
		let w = require('./wrongDoings');
		window.$wrongDoing = new w.WrongDoing();
		isWrongDoing = true;
		break;
		
	case 'event':
		let e = require('./events');
		window.$event = new e.VioletEvent();
		break;
		
	case 'events':
		let el = require('./eventList');
		window.$eventList = new el.VioletEventsList();
		break;
	
	case 'eventCalls':
		let ec = require('./eventCalls');
		window.$eventCalls = new ec.VioletEventCalls();
		break;
		
	case 'sheriffs':
		require('./sheriffs');
		window.$sheriff = new Sheriff();
		break;
		
	default:
		break;
}

if ($('.panel.wd-desperados').length > 0) {
	var d = require('./desperado');
	window.$desperadoController = new d.Desperado(isWrongDoing);
}

if ($body.hasClass('js-control-files')) {
	require('./exif');
	require('./filesControls');
	window.$filesControls = new FilesControls();
}

if ($body.hasClass('js-control-sheriffs')) {
	var sc = require('./sheriffControls');
	window.$sheriffControls = new sc.SheriffControls();
}

// Using day shifts controller
if ($('.js-use-day-shifts-controller').length > 0) {
	require('./dayShifts');
}

let $mapWrappers = $('#wdMapWrapper');
if ($mapWrappers.length > 0) {
	let m = require('./violetMap');
	$mapWrappers.each(function (i, el) {
		/*window.$violetMap = */new m.VioletMap($(el));
	});
}

if ($('form#registryForm')) {
	require('./registry');
}
